import { ONE_YEAR_IN_SECONDS } from '@src/utils/constants.util'

export function getBrowserCookie(name: string) {
  if (typeof document === 'undefined') return undefined
  const cookie = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`))
  return cookie ? decodeURIComponent(cookie.split('=')[1]) : undefined
}

export function setBrowserCookie(name: string, value: string, options?: string) {
  if (typeof document === 'undefined') return
  const defaultOptions = `path=/; max-age=${ONE_YEAR_IN_SECONDS}`
  document.cookie = `${name}=${value}; ${options ?? defaultOptions};`
}

export function removeBrowserCookie(name: string) {
  if (typeof document === 'undefined') return
  document.cookie = `${name}=; path=/; max-age=0;`
}

export function resetCookie(name: string, options?: string) {
  if (typeof document === 'undefined') return
  const decodedCookieValue = getBrowserCookie(name)
  if (!decodedCookieValue) return
  document.cookie = `${name}=${decodedCookieValue}; ${options ?? ''};`
}
